import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import LoadingScreen from './Common/LoadingScreen';

/**
 * Route Guard that checks if the user has permission for a specific module/action.
 * If not, redirects to dashboard or shows access denied.
 * 
 * @param {Object} props
 * @param {string} props.module - Module name (e.g., 'commissions', 'policies')
 * @param {string} props.action - Action name (e.g., 'view', 'create', 'edit')
 * @param {React.ReactNode} props.children - Child components to render if allowed
 */
const ModuleRouteGuard = ({ module, action = 'view', children }) => {
    const { checkPermission, loading, user } = useAuth();

    if (loading) {
        return <LoadingScreen message="Verificando permisos..." />;
    }

    if (!user) {
        return <Navigate to="/login" replace />;
    }

    const allowed = checkPermission(module, action);

    if (!allowed) {
        // Option: Redirect to dashboard with a toast/alert (handled by receiving page usually)
        // or just silent redirect
        console.warn(`Access denied to module: ${module}, action: ${action}`);
        return <Navigate to="/" replace />;
    }

    return children;
};

export default ModuleRouteGuard;
